// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".group-actions-container[data-v-3f8335a2] {\n  display: grid;\n  grid-auto-columns: auto;\n  grid-auto-flow: column;\n  justify-content: flex-end;\n  padding: 5px 0;\n  grid-column-gap: 4px;\n}\n.edit-menu-container[data-v-3f8335a2] {\n  display: grid;\n  grid-auto-flow: column;\n  justify-content: flex-start;\n  grid-column-gap: 10px;\n  position: relative;\n}\n.sticky[data-v-3f8335a2] {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background-color: transparent;\n}", ""]);
// Exports
module.exports = exports;
